import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "assets-wrap"
};
const _hoisted_2 = {
  key: 1,
  style: {
    "width": "100%",
    "height": "120px",
    "position": "relative"
  }
};
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 3,
  class: "sms-con"
};
const _hoisted_6 = {
  key: 4,
  class: "other-image"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  style: {
    "padding": "6px",
    "line-height": "15px"
  }
};
const _hoisted_9 = {
  class: "item-title"
};
const _hoisted_10 = {
  class: "bottom"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_image = _resolveComponent("el-image");
  const _component_el_card = _resolveComponent("el-card");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createBlock(_component_el_dialog, {
    title: "素材搜索",
    "model-value": $props.show,
    fullscreen: true,
    onClose: _cache[7] || (_cache[7] = $event => _ctx.$emit('update:show', false))
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form, {
      size: "small",
      inline: true,
      model: _ctx.form,
      class: "assets-form"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "关键字"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.form.keys,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.form.keys = $event),
          placeholder: "素材相关关键字"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "商品编码"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: _ctx.form.offerId,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.form.offerId = $event),
          placeholder: "OFFER_ID"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "素材状态"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: _ctx.form.status,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.form.status = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            value: "0",
            label: "已失效"
          }), _createVNode(_component_el_option, {
            value: "1",
            label: "生效中"
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          onClick: $setup.onSubmit
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("搜索", -1)]))]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: $setup.reset
        }, {
          default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("重置", -1)]))]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model"]), _createElementVNode("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.assetsList, i => {
      return _openBlock(), _createBlock(_component_el_card, {
        "body-style": {
          padding: '5px',
          cursor: 'pointer'
        },
        style: {
          "margin": "8px",
          "width": "220px"
        },
        key: i.id,
        onClick: $event => $setup.chooseHandler(i)
      }, {
        default: _withCtx(() => [i.srcTyp === '1' ? (_openBlock(), _createBlock(_component_el_image, {
          key: 0,
          style: {
            "width": "100%",
            "height": "120px"
          },
          fit: "scale-down",
          src: i.srcOutUrl ? i.srcOutUrl : i.srcInnUrl
        }, null, 8, ["src"])) : _createCommentVNode("", true), i.srcTyp === '2' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("audio", {
          style: {
            "width": "100%",
            "height": "120px",
            "position": "absolute",
            "bottom": "20%"
          },
          src: i.srcOutUrl ? i.srcOutUrl : i.srcInnUrl,
          controls: "controls"
        }, null, 8, _hoisted_3)])) : _createCommentVNode("", true), i.srcTyp === '3' ? (_openBlock(), _createElementBlock("video", {
          key: 2,
          width: "220",
          height: "120",
          src: i.srcOutUrl ? i.srcOutUrl : i.srcInnUrl,
          muted: "",
          controls: "controls"
        }, " 您的浏览器不支持 HTML5 video 标签。 ", 8, _hoisted_4)) : _createCommentVNode("", true), i.srcTyp === '7' ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(i.content), 1)) : _createCommentVNode("", true), i.srcTyp !== '1' && i.srcTyp !== '2' && i.srcTyp !== '3' && i.srcTyp !== '7' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("img", {
          style: {
            "width": "120px",
            "height": "120px"
          },
          src: _ctx.srcType[i.srcTyp] && _ctx.srcType[i.srcTyp].src ? _ctx.srcType[i.srcTyp].src : _ctx.srcType[6].src
        }, null, 8, _hoisted_7)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(i.assetsName), 1), _createElementVNode("div", _hoisted_10, [_createElementVNode("span", null, "生效时间：" + _toDisplayString(i.bgnDate), 1), _createElementVNode("span", null, "失效时间：" + _toDisplayString(i.endDate), 1)])])]),
        _: 2
      }, 1032, ["onClick"]);
    }), 128))]), _createVNode(_component_el_pagination, {
      background: "",
      "hide-on-single-page": true,
      total: _ctx.total,
      "page-size": _ctx.form.pageSize,
      modelValue: _ctx.form.pageNum,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.form.pageNum = $event),
      onCurrentChange: _cache[4] || (_cache[4] = v => _ctx.form.pageNum = v),
      onPrevClick: _cache[5] || (_cache[5] = v => _ctx.form.pageNum = v),
      onNextClick: _cache[6] || (_cache[6] = v => _ctx.form.pageNum = v)
    }, null, 8, ["total", "page-size", "modelValue"])]),
    _: 1
  }, 8, ["model-value"]);
}